import * as _  from './orderdetail.model';
import * as o from '../order/orderdisc.model';
import * as s from '../customer/shipto.model';
import * as etfoc from './etfoc.model';
export class OrderHeaderModel {
    txn_no: string = ""
    so_no: string = ""
    po_no: string = ""
    inv_no: string = ""
    currency: string = ""
    ord_type: string = ""
    payer_code:string= ""
    payer_name:string= ""
    pay_term_code: string = ""
    pay_term_name: string = ""
    cond_group_code: string = ""
    cond_group_name: string = ""
    pay_date: string = ""
    shipto_code: string = ""
    shipto_name: string = ""
    shipto: s.ShiptoModel = <s.ShiptoModel>{};
    required_delivery_date: string = ""
    // shipto_address: string = ""
    shipto_date: string = ""
    soldto_code: string = ""
    soldto_name: string = ""
    salesrep_code: string = ""
    salesorg: string = ""
    distchannel: string = ""
    division: string = ""
    remarks: string = ""
    attachment: string = ""
    contract_no: string = ""
    shipping_instruction: string = ""
    partial_delivery: string = ""
    detail: _.OrderDetailModel[] = [];
    cond_type: o.OrderDiscModel[] = [];
    ttl_ord_amt: number = 0
    ttl_disc_amt: number = 0
    ttl_tax_amt: number = 0
    ttl_net_amt: number = 0
    ttl_gross_amt: number = 0

    txn_status: string = ""

    foc_reason_code: string = ""
    foc_reason_name: string = ""

    //isprd_name_change: boolean = false

    acct_grp: string = ""
    o_cust_name : string = ""
    o_cust_name_1 : string = ""
    o_cust_name_2 : string = ""
    o_street2: string = ""
    o_street3: string = ""
    o_street5: string = ""
    o_district: string = ""
    o_diff_city: string = ""
    o_post_code: string = ""
    o_province: string = ""
    o_mob_no:  string=""
    o_tax_id: string = ""
    o_branch_code: string = ""
    o_bp_number: string = ""
    o_region: string = ""

    urgent_order_timeslot: string = ""
    urgent_order: Boolean = false
    affiliate_order: boolean = false;
    //STRY0017814-[TH] Print invoice date- 20-09-2022 -Start
    print_invoice_date:string;
    //STRY0017814-[TH]-Close
    sales_ind: string = ""
    order_reason: string = ""
    status :string = ""
    //Giang - STRY0017242 - To add additional field shipping condition in EPC
    shipping_condition: string = ""

    et_foc: etfoc.ETFOCModel[] = []
    //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital start
    custClassfication:string = ""
    //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital end
    is_manual_price_deleted:string = ""
    //CCLIORDER-2918- SG Quotation
    valid_until:any=""
    quotation_contact_email:string=""
    to_recipients:string=""
    mkt_manager_email:string=""
    // cc_recipients:string=""
    quotation_remarks:string
    ttl_surcharge_amount: number = 0
    // EO-3591_[TH] -Adding Change Description (CG2) Dropdown
    cond_group2_code:string = ""
    cond_group2_manual?: boolean
    ;
}



// WEBPACK FOOTER //
// ./src/models/order/orderheader.model.ts